var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBetalingVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 28",
    style: {
      enableBackground: "new 0 0 40 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#D4DBE0;}\n\t.st2{fill:url(#Path_175_00000160901079789939451610000014817205735115565210_);}\n\t.st3{fill:url(#Path_176_00000181787437923945954140000010797561529489446846_);}\n\t.st4{fill:url(#Path_177_00000167386328866926639090000009161296207284965812_);}\n\t.st5{fill:url(#Path_178_00000147196412443089076840000001286238004424637088_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    transform: "translate(-2119 -1293)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_461",
    transform: "translate(2119 1293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,0h32c2.2,0,4,1.8,4,4v20c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4,0.5h32c1.9,0,3.5,1.6,3.5,3.5v20c0,1.9-1.6,3.5-3.5,3.5H4c-1.9,0-3.5-1.6-3.5-3.5V4C0.5,2.1,2.1,0.5,4,0.5 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    transform: "translate(2125 1303.333)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_175_00000048481282456175148810000015033140278474042262_",
    gradientUnits: "userSpaceOnUse",
    x1: -585.3143,
    y1: 344.1433,
    x2: -582.0812,
    y2: 344.1634,
    gradientTransform: "matrix(7.794 0 0 -8.3854 4563.4565 2890.2766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#262860"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D429B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    style: {
      fill: "url(#Path_175_00000048481282456175148810000015033140278474042262_)"
    },
    d: "M26.8,8.5h-2 c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.1-0.1-0.2-0.2-0.2c-0.8,0-1.6,0-2.4,0c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.3-0.2,0.7-0.4,1 c0,0-0.1,0.1-0.1,0.1c-0.7,0-1.5,0-2.2,0c0.1-0.3,0.3-0.6,0.4-1l2.8-6.7c0.1-0.4,0.6-0.7,1-0.7h1.8c0.1,0.3,0.1,0.5,0.2,0.8 c0.5,2.2,0.9,4.4,1.4,6.7C26.7,7.9,26.8,8.2,26.8,8.5C26.8,8.5,26.8,8.5,26.8,8.5z M24.2,5.5l-0.6-3.1h0l-1.1,3.1H24.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_176_00000109740244948475375210000016469620606116885149_",
    gradientUnits: "userSpaceOnUse",
    x1: -569.3738,
    y1: 345.6028,
    x2: -565.5558,
    y2: 345.6218,
    gradientTransform: "matrix(6.596 0 0 -8.6715 3757.0791 3001.3347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#262860"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D429B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    style: {
      fill: "url(#Path_176_00000109740244948475375210000016469620606116885149_)"
    },
    d: "M18,0 c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0.1,0.5,0.1,0.7,0.2l-0.4,1.8c-0.3-0.1-0.7-0.2-1-0.3c-0.4-0.1-0.9-0.1-1.4,0 c-0.2,0.1-0.4,0.1-0.5,0.3c-0.2,0.2-0.3,0.5-0.1,0.7c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.4,0.3,0.6,0.4c0.4,0.3,0.9,0.5,1.3,0.8 c0.5,0.3,0.9,0.8,1,1.4c0.2,1-0.3,2-1.2,2.6c-0.6,0.4-1.2,0.6-1.9,0.6c-0.9,0.1-1.9,0-2.8-0.3c-0.1,0-0.1,0-0.2-0.1c0,0,0,0-0.1,0 l0.4-1.8c0.2,0.1,0.3,0.1,0.5,0.2C14.5,6.9,15.3,7,16,6.9c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.4-0.5,0.2-0.8c0-0.1-0.1-0.1-0.2-0.2 c-0.2-0.2-0.5-0.3-0.7-0.5c-0.4-0.2-0.8-0.4-1.2-0.7C14.3,4.1,14,3.6,13.9,3c-0.1-0.8,0.2-1.7,0.9-2.2c0.6-0.5,1.3-0.8,2.1-0.8 c0,0,0.1,0,0.1,0H18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_177_00000051384631858355984050000014272074815673970563_",
    gradientUnits: "userSpaceOnUse",
    x1: -602.798,
    y1: 344.2011,
    x2: -600.322,
    y2: 344.2212,
    gradientTransform: "matrix(10.176 0 0 -8.3932 6135.5679 2893.312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#262860"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D429B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    style: {
      fill: "url(#Path_177_00000051384631858355984050000014272074815673970563_)"
    },
    d: "M10.2,0.2 C10.1,0.4,10,0.7,9.8,0.9c-1,2.5-2.1,5-3.1,7.4c0,0.1-0.1,0.2-0.2,0.1c-0.7,0-1.3,0-2,0c-0.1,0-0.2,0-0.2-0.2 C3.8,6.2,3.2,4,2.6,1.9C2.6,1.5,2.3,1.2,2,1C1.4,0.8,0.7,0.6,0.1,0.4L0,0.4c0-0.3,0-0.3,0.2-0.3h3.4c0.5,0,1,0.3,1,0.9 C5,2.5,5.3,4.1,5.6,5.6c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.1c0.7-1.8,1.4-3.6,2.1-5.4c0-0.1,0.1-0.1,0.2-0.1c0.7,0,1.3,0,2,0 C10.1,0.1,10.1,0.2,10.2,0.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_178_00000178201424926027593900000006547740373778263683_",
    gradientUnits: "userSpaceOnUse",
    x1: -503.1324,
    y1: 344.1318,
    x2: -496.7854,
    y2: 344.1518,
    gradientTransform: "matrix(3.968 0 0 -8.3811 1997.9315 2888.624)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#262860"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D429B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    style: {
      fill: "url(#Path_178_00000178201424926027593900000006547740373778263683_)"
    },
    d: "M9.3,8.5l1.8-8.4h2.2 C13.2,0.6,13.1,1,13,1.4c-0.5,2.3-1,4.6-1.5,6.9c0,0.2-0.1,0.2-0.3,0.2c-0.6,0-1.2,0-1.8,0L9.3,8.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetalingVisa);
export default __webpack_public_path__ + "static/media/betaling-visa.56bdb2fa5a1a158afeef495ef685da6a.svg";
export { ForwardRef as ReactComponent };